import React from "react";

import "./OnboardingContentStyle.css";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { FaLongArrowAltRight } from "react-icons/fa";

const OnboardingContent = ({
  title,
  imgPath,
  onPrevClicked,
  onNextClicked,
  description,
}) => {
  return (
    <div className="swiper-content">
      <h2 className="text-gradient-primary">{title}</h2>

      <img src={imgPath} alt="" />

      <div className="description">{description}</div>

      {/* Handle prev button for cards - hides button if its the first card */}
      {onPrevClicked !== undefined ? (
        <button className="nav-button button-prev" onClick={onPrevClicked}>
          <FaLongArrowAltLeft />
        </button>
      ) : (
        <></>
      )}

      {/* Handle next button for cards - hides button, if its the last card */}
      {onNextClicked !== undefined ? (
        <button className="nav-button button-next" onClick={onNextClicked}>
          <FaLongArrowAltRight />
        </button>
      ) : (
        <></>
      )}
    </div>
  );
};

export default OnboardingContent;
